module.exports = __webpack_public_path__ + "static/media/promo-code-double-icon.bbc3ab2d.svg";